export default __webpack_public_path__ + "static/media/rocket-illustration.c9fcd55b.png";